
import { SaferGamblingModalsInterface } from '@central-products/interface-safer-gambling-modals';

import SaferGamblingModalsFeature from './SaferGamblingModalsFeature';

var feature = {
  name: '@feature/safer-gambling-modals',
  create: function create(config) {
    return new SaferGamblingModalsFeature(config);
  },
  dependsOn: [],
  implements: SaferGamblingModalsInterface,
  role: 'safer-gambling-modals'
};

export default feature;